import * as React from 'react';
import { CirclePicker } from 'react-color';

import { FieldHelperProps, FieldInputProps, FieldMetaProps, useField } from 'formik';
import { ColorAliases, Colors, FormGroup, FormGroupFeedback, IFormGroupProps, Intent } from '@pinpointhq/thumbtack';

interface IColorPickerFieldProps {
  colors: string[];
  name: string;
  formGroupProps?: Omit<IFormGroupProps, 'labelFor'>;
}

// We don't have a color picker in thumbtack yet, so have added this until we do. In the hope that this can just be
// changed here and not in all the different places that we use a color picker
export default function ColorPickerField<T extends string>(props: IColorPickerFieldProps) {
  const { colors, formGroupProps, name } = props;
  const [field, meta, helpers]: [FieldInputProps<T>, FieldMetaProps<T>, FieldHelperProps<T>] = useField<T>(name);
  const hasError = meta.touched && meta.error;

  const onColorChange = (color: { hex: string }) => {
    helpers.setValue(color.hex as T);
  };

  return (
    <FormGroup {...formGroupProps} labelFor={name}>
      <CirclePicker onChange={onColorChange} {...{ colors }} color={field.value} width="100%" />
      {hasError && <FormGroupFeedback intent={Intent.DANGER}>{meta.error}</FormGroupFeedback>}
    </FormGroup>
  );
}

ColorPickerField.defaultProps = {
  colors: [ColorAliases.DANGER, ColorAliases.SUCCESS, ColorAliases.WARNING, ColorAliases.PRIMARY, Colors.PEACH_50],
};
